export default {
  "contacts" : true,
  'games': true,
  'news': false,
  'partners': false,
  'company': false
}
